import React from "react";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaYoutube } from "react-icons/fa";
import UniLogo1 from "../images/uni6.jpg";
import UniLogo2 from "../images/uni2.webp";
import UniLogo3 from "../images/uni3.png";
import UniLogo4 from "../images/uni4.png";
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#02042b] text-white py-10 px-6">
      <div className="container mx-auto grid grid-cols-2 sm:grid-cols-2 md:grid-cols-5 gap-8 text-center md:text-left">
        
        {/* Services */}
       <div className="sm:col-span-1 md:col-span-1">
  <h3 className="text-lg font-semibold mb-4">Services</h3>

  <ul className="space-y-2 text-gray-400">
    <li>
      <Link to="/services" className="hover:text-white transition">
        Dissertation Writing
      </Link>
    </li>
    <li>
      <Link to="/services" className="hover:text-white transition">
        Report Writing
      </Link>
    </li>
    <li>
      <Link to="/services" className="hover:text-white transition">
        Thesis Writing
      </Link>
    </li>
    <li>
      <Link to="/services" className="hover:text-white transition">
        PPT & Poster Design
      </Link>
    </li>
    <li>
      <Link to="/services" className="hover:text-white transition">
        Essay Writing
      </Link>
    </li>
  </ul>
</div>


        {/* Packages */}
      <div className="sm:col-span-1 md:col-span-1">
  <h3 className="text-lg font-semibold mb-4">Assignment Assitance</h3>

  <ul className="space-y-2 text-gray-400">
    <li>
      <Link to="/services" className="hover:text-white transition">
        Management
      </Link>
    </li>

    <li>
      <Link to="/services" className="hover:text-white transition">
        Law
      </Link>
    </li>

    <li>
      <Link to="/services" className="hover:text-white transition">
        Finance
      </Link>
    </li>

    <li>
      <Link to="/services" className="hover:text-white transition">
        Engineering
      </Link>
    </li>

    <li>
      <Link to="/services" className="hover:text-white transition">
        Programming
      </Link>
    </li>

    <li>
      <Link to="/services" className="hover:text-white transition">
        Networking
      </Link>
    </li>

    <li>
      <Link to="/services" className="hover:text-white transition">
        Arts &amp; Humanities
      </Link>
    </li>

    <li>
      <Link to="/services" className="hover:text-white transition">
        Science
      </Link>
    </li>
  </ul>
</div>


        {/* Agency */}
        <div className="sm:col-span-1 md:col-span-1">
  <h3 className="text-lg font-semibold mb-4">Resources

  </h3>
 <ul className="space-y-2 text-gray-400">
  <li><Link to="/aboutus" className="hover:text-white transition">About Us</Link></li>
  <li><Link to="/whyus" className="hover:text-white transition">Blogs</Link></li>
  <li><Link to="/samples" className="hover:text-white transition">Samples</Link></li>
  <li><Link to="/services" className="hover:text-white transition">Services</Link></li>
  <li><Link to="/contactus" className="hover:text-white transition">Contact Us</Link></li>
</ul>

</div>


        {/* Payment Accepted (Stair-Step Layout) */}
        <div className="sm:col-span-2 md:col-span-1">
          <h3 className="text-lg font-semibold mb-4">Payment Accepted</h3>
          <div className="flex flex-col items-start space-y-2">
          <img
    src="https://cdn.iconscout.com/icon/free/png-512/free-upi-logo-icon-download-in-svg-png-gif-file-formats--unified-payments-interface-payment-money-transfer-logos-icons-1747946.png?f=webp&w=512"
    alt="BHIM"
    className="h-14 w-auto object-contain"
  />
  <img
    src="https://brandlogos.net/wp-content/uploads/2022/03/wise-logo-brandlogos.net_-300x300.png"
    alt="Wise"
    className="h-16 w-auto object-contain"
  />
  <img
    src="https://cdn1.iconfinder.com/data/icons/logos-brands-in-colors/436/Google_Pay_GPay_Logo-512.png"
    alt="GPay"
    className="h-14 w-auto object-contain"
  />
  <img
    src="https://companieslogo.com/img/orig/RELY_BIG.D-c9afc882.png?t=1720244493"
    alt="Remitly"
    className="h-16 w-16 object-contain"
  />
          </div>
        </div>

        {/* Contact Us */}
        <div className="xs:col-span-2 md:col-span-1">
          <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
          <p className="text-gray-200 text-sm mb-2 ">📍119/G/3,D.P.J.M ROAD, BUDGE BUDGE, SOUTH TWENTY FOUR PARGANAS
South Twenty Four Parganas
          </p>
          <p className="text-gray-200 text-sm mb-2">📧  infinitesolutionedu@gmail.com <br /> contact@infinitesolutionedu.com</p>
          <p className="text-gray-200 text-sm">📱 +91 89815 38013</p>

          {/* Google Map */}
          <div className="mt-4">
          <iframe
  title="Google Map"
  className="w-full h-32 rounded-md"
  src="https://www.google.com/maps?q=2nd+Floor,+Dainhat+Bazar+Paddarani+Market,+Purba+Burdwan,+West+Bengal,+India,+Pin-713502&output=embed"
  allowfullscreen
  loading="lazy"
></iframe>

          </div>
        </div>
      </div>

      {/* Social Media Links */}
      <div className="mt-10 border-t border-gray-700 pt-6 flex flex-col md:flex-row items-center justify-between text-sm text-gray-400">
  {/* Social Media Icons */}
 {/* Social Media Icons */}
<div className="flex space-x-6">
  <a href="https://www.facebook.com/profile.php?id=100090187670385" target="_blank" rel="noopener noreferrer">
    <FaFacebookF className="hover:text-blue-500 cursor-pointer" size={20} />
  </a>
  <a href="https://www.linkedin.com/company/infinitesolutionsedu/" target="_blank" rel="noopener noreferrer">
    <FaLinkedinIn className="hover:text-blue-600 cursor-pointer" size={20} />
  </a>
  <a href="https://www.youtube.com/channel/yourchannel" target="_blank" rel="noopener noreferrer">
    <FaYoutube className="hover:text-red-500 cursor-pointer" size={20} />
  </a>
  <a href="https://www.instagram.com/infinitesolution_/" target="_blank" rel="noopener noreferrer">
    <FaInstagram className="hover:text-pink-500 cursor-pointer" size={20} />
  </a>
</div>


  {/* University Logos */}
  <div className="flex space-x-4 mt-4 md:mt-0">
        <img src={UniLogo1} alt="University 1" className="h-12 w-auto object-contain" />
        <img src={UniLogo2} alt="University 2" className="h-12 w-auto object-contain" />
        <img src={UniLogo3} alt="University 3" className="h-12 w-auto object-contain" />
       
      </div>

  {/* Copyright Text */}
  <p className="mt-4 md:mt-0 text-center md:text-right">
    © 2026 Infinite Solution. All Rights Reserved.
  </p>
</div>

    </footer>
  );
};

export default Footer;
